import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    config: {
      logo: 'assets/images/logos/latercera.svg',
      title: 'Bancoestado',
      url: 'https://www.latercera.com/canal/tendencias',
      papeldigital: true,
      baseurl: 'https://especiales.latercera.com/valientes-bancoestado',
      description: 'Valientes Bancoestado',
      hashtag: '#valientesbancoestado',
      brandtitle: 'Presentado por BancoEstado',
      reporttitle: 'Especiales La Tercera',
      jumbo: {
        video: 'content/loop-bancoestado2-compressed.mp4',
        under: '',
      },
      img: 'content/share.jpg',
      slug: '/',
      lab: {
        logo: 'assets/images/logos-white/laboratorio-de-contenidos-de-marca.svg',
        title: 'Laboratorio de Contenidos',
        url: {
          name: "home"
        },
        height: '30'
      },
      brand: {
        logo: 'assets/images/logos-white/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '20'
      },
      sponsor: {
        logo: 'assets/images/logo-bancoestado.svg',
        title: 'Bancoestado',
        url: {
          name: "home"
        },
        height: '45'
      },
      special: {
        logo: 'assets/images/logo-valientes.svg',
        title: 'Valientes',
        url: {
          name: "home"
        },
        height: '40'
      },
      front: {
        logo: 'assets/images/logo-valientes.svg',
        title: 'Valientes',
        url: {
          name: "home"
        },
        height: '400'
      },
      site: {
        logo: 'assets/images/logos/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '37'
      },
      menu: {
        logo: 'assets/images/logos/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '13'
      },
      'papeldata': {
        url: 'https://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&pubid=33084897-397a-48cc-b3c0-3ce1ec447137',
        image: 'https://edition.pagesuite-professional.co.uk/get_image.aspx?w=300&pbid=33084897-397a-48cc-b3c0-3ce1ec447137&pnum=01&nocache=0609201815'
      },
      'navigation': [
        {
          url: 'https://www.latercera.com/',
          name: 'Inicio'
        },
        {
          url: 'https://www.latercera.com/la-tercera-pm/',
          name: 'La Tercera PM'
        },
        {
          url: 'https: //www.latercera.com/canal/pulso/',
          name: 'Pulso'
        },
        {
          url: 'https://www.latercera.com/canal/politica/',
          name: 'Política'
        },
        {
          url: 'https://www.latercera.com/canal/nacional/',
          name: 'Nacional'
        },
        {
          url: 'https://www.latercera.com/canal/mundo/',
          name: 'Mundo'
        },
        {
          url: 'https://www.latercera.com/canal/opinion/',
          name: 'Opinión'
        },
        {
          url: 'https://www.latercera.com/canal/tendencias/',
          name: 'Tendencias'
        },
        {
          url: 'https://www.latercera.com/canal/cultura/',
          name: 'Cultura'
        },
        {
          url: 'https://www.latercera.com/canal/cultura/',
          name: 'Entretención'
        },
        {
          url: 'https://www.latercera.com/canal/reportajes/',
          name: 'Reportajes'
        },
        {
          url: 'https://www.latercera.com/canal/el-deportivo/',
          name: 'El Deportivo'
        },
        {
          url: 'https://www.latercera.com/canal/la-tercera-tv/',
          name: 'La Tercera TV'
        },
        {
          url: 'http://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&pubid=33084897-397a-48cc-b3c0-3ce1ec447137',
          name: 'Edición Impresa'
        }
      ],
      'socialnetworks': [
        {
          url: 'https://twitter.com/latercera',
          icon: 'twitter', //TODO, cargar svgs dinámicamente en init
          name: 'Twitter'
        },
        {
          url: 'https://www.facebook.com/laterceracom',
          icon: 'facebook-f', //TODO, cargar svgs dinámicamente en init
          name: 'Facebook'
        },
        {
          url: 'https://flipboard.com/@latercera',
          icon: 'flipboard', //TODO, cargar svgs dinámicamente en init
          name: 'Flipboard'
        },
        {
          url: 'https://www.instagram.com/laterceracom/',
          icon: 'instagram', //TODO, cargar svgs dinámicamente en init
          name: 'Instagram'
        },
        {
          url: 'https://www.youtube.com/user/latercera',
          icon: 'youtube', //TODO, cargar svgs dinámicamente en init
          name: 'Youtube'
        }
      ]
    },
    articles: [
      {
        firstname: 'Luis Gregorio',
        lastname: 'Cares',
        video: 'bGCqJj',
        slug: 'luis-cares',
        age: '45 años',
        city: 'Curarrehue, Región de la Araucanía',
        prizetitle: 'Ganador Comercio Servicios',
        prize: 'Minimercado “La Araucanía”, un negocio de productos de primera necesidad. Su premio es un vehículo de trabajo.',
        capital: 'Comenzó el año 2000 con 200 mil pesos.',
        employees: 'Al momento de empezar tenía un empleado, ahora son 4 personas.',
        lesson: '“Saber soportar el tiempo de las vacas flacas. Puede parecer que todo se va a terminar y que están malas las ventas, pero hay que seguir adelante pensando que el día de mañana va a estar mejor”',
        share: {
          title: 'Valientes: Luis Gregorio Cares',
          description: 'Luis Cares fue uno de los ganadores del Premio al Emprendedor, otorgado por BancoEstado. El reconocimiento  se debe a su emprendimiento “La Araucanía”, un negocio de productos de primera necesidad. Revisa su historia.',
          img: 'content/share-luis-cares.jpg',
        },
      },
      {
        firstname: 'María del Pilar',
        lastname: 'Garrido',
        video: 'bGCqJW',
        slug: 'maria-garrido',
        age: '61 años',
        city: 'Talcahuano, Región del Bío Bío.',
        prizetitle: 'Ganadora Transporte',
        prize: 'Transporte, Radiotaxis. Su premio fue un vehículo de trabajo.',
        capital: 'Su capital inicial fue de nueve millones y comenzó el año 2008.',
        employees: 'Comenzó con un empleado, hoy tiene tres.',
        lesson: '“Ser muy ordenado en todo tipo de documentación, dinero, y tomar decisiones para aumentar volumen de trabajo”',
        share: {
          title: 'Valientes: María del Pilar Garrido',
          description: 'María del Pilar Garrido, de Talcahuano, fue una de las ganadoras en la categoría Transporte, del Premio al Emprendedor, otorgado por BancoEstado. Su premio fue un vehículo para sumar a su negocio de radiotaxis. Revisa su historia.',
          img: 'content/share-maria-garrido.jpg',
        },
      },
      {
        firstname: 'Marlene',
        lastname: 'Barría',
        video: 'bGCqK1',
        slug: 'marlene-barria',
        age: '38 años',
        city: 'Puerto Montt, Región de Los Lagos.',
        prizetitle: 'Ganadora Innovación',
        prize: 'Fabricación de pecheras de tela hípora, reutilizables y lavables, para los trabajadores de salmoneras que se desempeñan en plantas de proceso. A diferencia de las que se acostumbran a usar en estas labores, que son de plástico y que luego de un uso deben desecharse. Su premio es de seis millones de pesos.',
        capital: 'Comenzó con un capital de cuatro millones en 2018.',
        employees: 'Empezó con dos personas y ahora son seis en total.',
        lesson: '“A quienes aún no se atreven a emprender, les digo que al principio cuesta ser independiente, es difícil, pero hay que seguir adelante y cumplir los sueños”.',
        share: {
          title: 'Valientes: Marlene Barría',
          description: 'Marlene Barría, de Puerto Montt, fue una de las ganadoras del Premio al Emprendedor, de BancoEstado. Su emprendimiento consiste en la fabricación de pecheras de tela hípora, reutilizables y lavables, para los trabadores de salmoneras. Revisa su historia.',
          img: 'content/share-marlene-barria.jpg',
        },
      },
      {
        firstname: 'Rolando',
        lastname: 'Navarrete',
        video: 'bGCqKU',
        slug: 'rolando-navarrete',
        age: '41 años',
        city: 'Panguipulli, Región de Los Ríos.',
        prizetitle: 'Ganador Transporte',
        prize: 'Empresa de transporte escolar que en verano funciona como transporte agrícola. Su premio fue un vehículo de trabajo.',
        capital: 'Partió el año 2006 y su  capital inicial fue de un millón y medio. ',
        employees: 'Al empezar era solo él y hoy tiene tres empleados.',
        lesson: '“No rendirse nunca, jamás. Aunque haya dificultades, buscar la forma de ver cómo se pueden solucionar las cosas y adecuar el negocio a los nuevos requerimientos y normativas”.',
        share: {
          title: 'Valientes: Rolando Navarrete',
          description: 'En 2006, Rolando Navarrete comenzó con su empresa de transporte escolar. Hoy, fue reconocido con el Premio al Emprendendor y recibió un vehículo de trabajo. Conoce a continuación su historia.',
          img: 'content/share-rolando-navarrete.jpg',
        },
      },
      {
        firstname: 'Teresa',
        lastname: 'Pacaje',
        video: 'bGCqL4',
        slug: 'teresa-pacaje',
        age: '64 años',
        city: 'Putre, Región de Arica y Parinacota',
        prizetitle: 'Ganador Agrícola Pesca Turismo',
        prize: 'Artesanía Picaflor Andino, confecciones con hilo y lana de Alpaca. Ganó un vehículo de trabajo.',
        capital: 'Comenzó en junio de 2018, con un capital de 20 millones de pesos.',
        employees: 'Trabaja sola.',
        lesson: '“Tener ganas de emprender. Yo no sé leer ni escribir y mi nieto me ayudó a postular para este premio. Nunca he tenido un reconocimiento, ya que soy nortina y no hay mucho emprendimiento. Pero si amas lo que haces, todo es posible”',
        share: {
          title: 'Valientes: Teresa Pacaje',
          description: 'Teresa Pacaje fue ganadora de la categoría agrícola, pesca y turismo, del Premio al Emprendedor, de BancoEstado. Su negocio consiste en confecciones con hilo y lana de Alpaca. Conoce su historia.',
          img: 'content/share-teresa-pacaje.jpg',
        },
      },
      {
        firstname: 'Cristian',
        lastname: 'ORyan',
        video: 'bGEMAP',
        slug: 'cristian-oryan',
        age: '39 años',
        city: 'Santiago, Región Metropolitana',
        prizetitle: 'Ganador Innovación',
        prize: 'Empresa social que busca disminuir la pobreza energética de las familias chilenas y de Latinoamérica. Está dirigida a zonas rurales con familias vulnerables, donde el acceso a energía es deficiente o nulo. Su premio es de seis millones de pesos.',
        capital: 'Su capital inicial fue de $8 millones y comenzó a emprender en 2017.',
        employees: 'Dos trabajadores.',
        lesson: '“Enamorarse del problema y no de la solución. Si algo no salía como queríamos, seguíamos pensando en cómo solucionar el problema de pobreza energética. Eso nos permitió seguir avanzando”.',
        share: {
          title: 'Valientes: Cristian O\'Ryan',
          description: 'Cristián O’ryan fue otro de los ganadores del Premio al Emprendedor, otorgado por BancoEstado. La empresa que creó en 2017, busca disminuir la pobreza energética de las familias chilenas y latinoamericanas. Revisa su historia.',
          img: 'content/share-cristian-oryan.jpg',
        },
      },
      {
        firstname: 'Elsa',
        lastname: 'Herrera',
        video: 'bGCqMx',
        slug: 'elsa-herrera',
        age: '31 años',
        city: 'Santiago, Región Metropolitana',
        prizetitle: 'Ganador Comercio Servicios',
        prize: 'Cocodrilo Bazar, una tienda vegana de bolsos y mochilas, la primera en ser certificada 100% como vegana. Ganó un vehículo de trabajo.',
        capital: 'Comenzó el año 2008 con 15 mil pesos.',
        employees: 'Al comienzo, ella y su socio. Hoy son seis trabajadores.',
        lesson: '“Lo más importante es ser perseverante y resiliente. Si en el camino te encuentras con alguna falla, algún error o algún fracaso, hay que seguir adelante independiente del problema que tengas”.',
        share: {
          title: 'Valientes: Elsa Herrera',
          description: 'Elsa Herrera, comenzó con Cocodrilo Bazar, tienda vegana de bolsos y mochilas, en 2008. Hoy, fue una de las ganadoras del Premio al Emprendedor, de BancoEstado.',
          img: 'content/share-elsa-herrera.jpg',
        },
      },
      {
        firstname: 'Fernando',
        lastname: 'Miranda',
        video: 'bGCqMP',
        slug: 'fernando-miranda',
        age: '65 años',
        city: 'San Andrés de Pica, Región de Tarapacá',
        prizetitle: 'Ganador Agrícola Pesca Turismo',
        prize: 'Proyecto Pampa Ilusión, una plantación de árboles frutales de limones, naranjas, mangos, pomelos y guayabas en medio del desierto. Ganó un vehículo de trabajo.',
        capital: 'El proyecto nace el año 2000, con un capital de 12 millones de pesos.',
        employees: 'Tres trabajadores más la familia.',
        lesson: '“Desde 1980 en adelante que estoy cumpliendo el sueño de crear un manto verde en el norte y no ha sido fácil. En las zonas alejadas los trámites pueden durar años, pero nunca hay que rendirse”.',
        share: {
          title: 'Valientes: Fernando Miranda',
          description: 'Su proyecto Pampa Ilusión, que consiste en una plantación de árboles frutales de limones, naranjas, mangos, pomelos y guayabas, en medio del desierto, fue reconocido por el Premio al Emprendedor, de BancoEstado. Revisa su historia.',
          img: 'content/share-fernando-miranda.jpg',
        },
      },
      {
        firstname: 'Jorge',
        lastname: 'Canto',
        video: 'bGCqNo',
        slug: 'jorge-canto',
        age: '46 años',
        city: 'Coihueco, Región de Ñuble.',
        prizetitle: 'Ganador Pequeñas Empresas',
        prize: 'Tiene 15 hectáreas de berries orgánicas y 10 hectáreas de espárragos. Su premio es un vehículo de trabajo.',
        capital: 'Comenzó con dos millones y medio. Partió en 2013.',
        employees: 'Empezó con cuatro personas y ahora son seis en total. En tiempo de cosecha, el número asciende a 25 o 30 personas.',
        lesson: '“Nunca hay que echarse a morir, independiente de los altos y bajos que uno tenga en la vida. Siempre hay que mirar para adelante, proyectarse hacia el futuro y lograr nuestros sueños”.',
        share: {
          title: 'Valientes: Jorge Canto',
          description: 'Ganó con su plantación de 15 hectáreas de berries orgánicas y 10 hectáreas de espárragos.',
          img: 'content/share-jorge-canto.jpg',
        },
      },
      {
        firstname: 'Karen',
        lastname: 'Rodríguez',
        video: 'bGCqN9',
        slug: 'karen-rodriguez',
        age: '35 años',
        city: 'Santiago, Región Metropolitana.',
        prizetitle: 'Ganadora Pequeñas Empresas',
        prize: 'Dos restaurantes, ubicados en una de las calles más concurridas del Persa Biobío: Colapez, de comida peruana, y Rumba, una sandwichería. Recibirá un vehículo de trabajo',
        capital: 'Empezó con un millón en 2008.',
        employees: 'Comenzó trabajando con tres personas. Actualmente, cuenta con un total de 12 trabajadores en Colapez y ocho en Rumba.',
        lesson: '“Ser perseverante es lo único que te puede conducir al éxito. Superar los momentos difíciles. Hay que atreverse, trabajar mucho y, a veces, no tener vacaciones. Es un gran sacrificio, pero es harta la recompensa”.',
        share: {
          title: 'Valientes: Karen Rodríguez',
          description: 'Ganó con dos restaurantes, ubicados en una de las calles más concurridas del Persa Biobío: Colapez, de comida peruana, y Rumba, una sandwichería.',
          img: 'content/share-karen-rodriguez.jpg',
        },
      },
    ]
  },
  mutations: {
    SET_LOGO: (state, val) => {
      state.config.logo = val
    }
  },
  actions: {
    setLogo(context, val) {
      context.commit('SET_LOGO', val)
    }
  },
  getters: {
    getArticle: (state) => (slug) => {
      const articlearr = state.articles.filter(i => i.slug === slug)
      return articlearr[0]
    },
    getArticleIndex: (state) => (slug) => {
      const articleIndex = state.articles.findIndex(i => i.slug === slug)
      return articleIndex
    },
    getArticlesByCategory: (state) => (category) => {
      const articlearr = state.articles.filter(i => i.category === category)
      return articlearr
    }
  }
})
